import React from "react";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config";

const CreateAdmin = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "ADMIN", // Default role as only "ADMIN" is allowed
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const token = localStorage.getItem("authToken");
      // The server always creates this account as ADMIN regardless of
      // what's sent (the dropdown below is informational only, not a real
      // choice) - and its Joi validation schema doesn't include `role` as
      // an allowed key at all, so sending it here was always rejected
      // with "role is not allowed".
      const { role, ...payload } = formData;
      const response = await axios.post(
        `${API_BASE_URL}/auth/create-admin`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      alert(response.data.message);
      navigate("/");
    } catch (err) {
      setError(err.response?.data || "Something went wrong");
    }
  };

  return (
    <div className="p-6">
      <div className="max-w-lg mx-auto p-6 bg-card border border-line rounded-lg">
      <h2 className="text-2xl font-semibold text-center mb-4 text-ink">Create Admin</h2>
      {error && <p className="text-primary text-center">{error}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-medium">First Name</label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            className="w-full p-2 border border-line rounded-lg"
            required
          />
        </div>
        <div>
          <label className="block font-medium">Last Name</label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            className="w-full p-2 border border-line rounded-lg"
          />
        </div>
        <div>
          <label className="block font-medium">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-2 border border-line rounded-lg"
            required
          />
        </div>
        <div>
          <label className="block font-medium">Password</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            className="w-full p-2 border border-line rounded-lg"
            required
          />
        </div>
        <div>
          <label className="block font-medium">Role</label>
          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
            className="w-full p-2 border border-line rounded-lg bg-paper cursor-not-allowed"
            disabled
          >
            <option value="ADMIN">Admin</option>
          </select>
        </div>
        <button
          type="submit"
          className="w-full bg-primary text-white p-2 rounded-lg hover:opacity-90 transition"
        >
          Create Admin
        </button>
      </form>
      </div>
    </div>
  );
};

export default CreateAdmin;
